export default "__VITE_ASSET__DJ6Iomu1__"